// GES-435: the numbering / avoir / document-field refusals in the user's language. The API sends `error` (EN) and `error_fr`; for the codes below the web has its own
// EN+FR sentence (invoicing:refusal.<CODE>) filled from the refusal's figures (money formatted, document types named); any other refusal falls back to the API's text.
import i18n from '../../i18n';
import { formatMoneyExact } from '../../utils/format';
import { errText } from '../../pages/Sales/invoicing/invoicingModel.mjs';

const MONEY = ['cap', 'remaining', 'invoice_total', 'already_credited', 'amount', 'recognised'];
export function refusalText(e, lang) {
  const b = e?.body || {}; const lng = (lang || i18n.language || 'en').startsWith('fr') ? 'fr' : 'en';
  const key = `invoicing:refusal.${b.code}`;
  if (!b.code || !i18n.exists(key, { lng })) return errText(e, lng);
  const p = { ...b, lng };
  MONEY.forEach(k => { if (b[k] != null) p[k] = formatMoneyExact(b[k]); });
  ['doc_type', 'follows'].forEach(k => { if (b[k]) p[k] = i18n.t(`invoicing:numKind_${b[k]}`, { lng }); });
  if (b.label) p.label = lng === 'fr' ? b.label_fr || b.label : b.label;
  return i18n.t(key, p);
}

// the same for a requestRaw result ({ok:false, status, data:{code, error, error_fr}}) used by the avoir calls
export const refusalFromRes = (res, lang) => refusalText({ body: res?.data, message: `HTTP ${res?.status || ''}`.trim() }, lang);
